import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { PatientAccount } from 'src/app/models/PatientAccount';
import { ApiResult, PromiseResult, ServerError } from 'src/app/models/PromiseResult';

@Component({
    selector: 'app-patient-basic-details',
    templateUrl: './patient-basic-details.component.html',
    styleUrls: ['./patient-basic-details.component.css',
        '../../../../../assets/css/custom-egd.css']
})
@TraceClassDecorator()
export class PatientBasicDetailsComponent implements OnInit {

    @Input('api_result')
    api_result: ApiResult = new ApiResult(true);

    patientData: PatientAccount = null;

    constructor() { }
    async ngOnInit(): Promise<void> { }

    init() {
        this.patientData = this.api_result.PromiseResult.data;
    }

}
